(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }, 300))
  }
}
customElements.define('cart-note', CartNote);

// Just plain JS — no {% if ... %} anymore
let couponCodeField = document.getElementById('coupon_code_cart'),
    couponCodeGet = localStorage.getItem("coupon");
if (couponCodeField) {
  couponCodeField.value = couponCodeGet;
}

  } catch(e) { console.error(e); }
})();
})();
